/* eslint-disable @mizdra/layout-shift/require-size-attributes */
// This variant of spotlight is deprecated and is not approved for general use
// It was added exclusively and temporarily to support the timeline of the B2B homepage migration in q3 of 2022.
import React from 'react';
import proptypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames/bind';
import {
  Button,
  Card,
  CardMedia,
  CardTitle,
  Link
} from '@one-thd/sui-atomic-components';
import { publish } from './utils/publisher';

const { number, string, shape, bool } = proptypes;

const cardContentProps = {
  initialSize: 'full'
};

const getB2BSpotlightData = ({
  dataComponent,
  isSlotData,
  titleProp,
  linkProp,
  ctaProp,
  altTextProp,
  imageUrlProp,
  proAnalyticsCampaignProp,
  proAnalyticsComponentProp

}) => {

  const data = {
    cta: null,
    link: null,
    title: null,
    altText: null,
    proAnalyticsCampaign: null,
    proAnalyticsComponent: null,
    imageUrl: null
  };
  if (dataComponent) {
    data.cta = dataComponent.cta;
    data.link = dataComponent.link;
    data.title = dataComponent.title;
    data.altText = dataComponent.altText;
    data.proAnalyticsCampaign = dataComponent.proAnalyticsCampaign;
    data.proAnalyticsComponent = dataComponent.proAnalyticsComponent;

    const {
      previewImage: dataComponentPreviewImage
    } = dataComponent || {};

    const damDownloadedContentImage = dataComponentPreviewImage?.damDownloadedContent;

    if (damDownloadedContentImage?.url) {
      data.imageUrl = damDownloadedContentImage?.url;
    } else {
      data.imageUrl = dataComponentPreviewImage?.damContentSelector?.assetData?.[0]?.selectedImageUrl;
    }
  } else if (isSlotData) {
    data.cta = ctaProp;
    data.link = linkProp;
    data.title = titleProp;
    data.altText = altTextProp;
    data.proAnalyticsCampaign = proAnalyticsCampaignProp;
    data.proAnalyticsComponent = proAnalyticsComponentProp;
    data.imageUrl = imageUrlProp;

  }

  return data;
};

const SpotlightB2b = ({
  componentId,
  componentClass = '',
  componentPosition = 1,
  proAnalyticsData = {},
  title: titleProp = '',
  link: linkProp = '',
  cta: ctaProp = '',
  altText: altTextProp = '',
  imageUrl: imageUrlProp = '',
  proAnalyticsCampaign: proAnalyticsCampaignProp = '',
  proAnalyticsComponent: proAnalyticsComponentProp = '',
  isSlotData = false,
}) => {

  const { data } = useDataModel('component', {
    variables: {
      id: componentId,
      componentClass
    },
    skip: isSlotData,
  });

  const impressionProviderContextData = useImpression({
    data: {
      id: componentId,
      name: 'Spotlight',
      component: 'Spotlight',
      position: componentPosition,
      type: 'content'
    }
  });

  const dataComponent = data?.component;

  const {
    cta,
    link,
    title,
    altText,
    proAnalyticsCampaign,
    proAnalyticsComponent,
    imageUrl
  } = getB2BSpotlightData({
    dataComponent,
    isSlotData,
    titleProp,
    linkProp,
    ctaProp,
    altTextProp,
    imageUrlProp,
    proAnalyticsCampaignProp,
    proAnalyticsComponentProp
  });

  const handleContentClick = () => {
    if (proAnalyticsData.isB2B) {
      // Input Data for widget should be collected from component data
      publish({
        widgetId: componentId,
        widgetTemplates: proAnalyticsData.templates,
        widgetCampaign: proAnalyticsCampaign,
        widgetComponent: proAnalyticsComponent,
      });
    }
  };

  return (
    <div
      data-component-id={componentId}
      id={`${componentClass}-${componentPosition}-${componentId}`}
      data-component="SpotlightB2b"
      data-component-name="Spotlight"
      data-component-position={componentPosition}
      data-testid="spotlightB2b"
      className="sui-grid sui-w-full"
      ref={impressionProviderContextData.ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={impressionProviderContextData.clickID}
    >
      <Link href={link} underline="none" onClick={handleContentClick}>
        <Card className="sui-flex" CardContentProps={cardContentProps}>
          {/* eslint-disable-next-line max-len,tailwindcss/no-arbitrary-value */}
          <div className="sui-flex sui-flex-row sui-max-h-[13rem] sui-h-full sm:sui-flex-col sm:sui-max-h-[none] lg:sui-flex-row lg:sui-max-h-[13rem]">
            {/* eslint-disable-next-line max-len */}
            <div className="sui-flex sui-flex-col sui-w-7/12 sui-justify-between sui-grow sm:sui-order-last sm:sui-w-full sm:sui-mt-2 lg:sui-order-none lg:sui-w-7/12 lg:sui-mt-0">
              <CardTitle header={title} />
              <div className="sui-whitespace-nowrap">
                <Button variant="text" fullWidth>{cta || ''}</Button>
              </div>
            </div>
            {/* eslint-disable-next-line max-len,tailwindcss/no-arbitrary-value */}
            <div className="sui-max-w-[13rem] sui-ml-4 sui-aspect-square sm:sui-ml-0 sm:sui-order-first sm:sui-max-w-[none] sm:sui-w-full lg:sui-ml-4 lg:sui-order-none lg:sui-max-w-[13rem]">
              <CardMedia
                src={imageUrl}
                aspect="square"
                alt={altText || title}
                title={altText || title}
              />
            </div>
          </div>
        </Card>
      </Link>
    </div>
  );
};

SpotlightB2b.propTypes = {
  componentId: string.isRequired,
  componentPosition: number,
  componentClass: string,
  proAnalyticsData: shape({
    isB2B: bool,
    templates: string
  }),
  title: string,
  link: string,
  cta: string,
  altText: string,
  imageUrl: string,
  proAnalyticsCampaign: string,
  proAnalyticsComponent: string,
  isSlotData: bool,
};

SpotlightB2b.displayName = 'SpotlightB2b';

export { SpotlightB2b };
